export default class Modes {
  public static CLOSED_BY_DEFAULT = "0";
  public static OPEN_BY_DEFAULT_AND_DESAPPEARES_IF_CLOSED = "1";

  /**
   * The widget IS the page: its own URL, no host site around it, no launcher
   * and nothing to close. Full screen on mobile, a centered app card on
   * desktop. Set by the standalone entry point, never by the embed script.
   */
  public static STANDALONE = "standalone";

  /**
   * No launcher at all — the host site drives everything through
   * `window.PlutoniosChat`. The chat surface is still the ordinary floating
   * one; it simply has no way in other than the host's own UI.
   */
  public static CONTROLLED = "controlled";

  /** Modes that render no launcher bubble of their own. */
  public static hidesLauncher(mode?: string) {
    return (
      mode === Modes.OPEN_BY_DEFAULT_AND_DESAPPEARES_IF_CLOSED ||
      mode === Modes.CONTROLLED ||
      mode === Modes.STANDALONE
    );
  }

  public static isStandalone(mode?: string) {
    return mode === Modes.STANDALONE;
  }
}
